export const DELETED_USERS_PARAM = 'usuarios_deletados';
